export const AUTH_CSRF = "auth/csrf/"
export const AUTH_LOGIN = "auth/login/"
export const AUTH_LOGOUT = "auth/logout/"
export const AUTH_MICROSOFT_LOGIN = "api/login_athen"
export const AUTH_MICROSOFT_CALLBACK = "api/callback/"
export const AUTH_USER = "auth/user/"
